import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import { component } from 'vue/types/umd'

Vue.use(VueRouter)

  const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: "/health",
  },
  {
    path: '/createCard',
    name: 'createCard',
    component: () => import('@/views/CreateCard.vue')
  },
  {
    path: '/blh',
    name: 'blh',
    component: ()=> import('@/views/Blh.vue')
  },
  {
    path: '/health',
    name: 'health',
    component: ()=> import('@/views/Health.vue')
  },
  {
    path: '/master',
    name: 'master',
    component: ()=> import('@/views/Master.vue')
  },{
    path: '/healthAdvisory',
    name: 'healthAdvisory',
    component: () => import('@/views/healthAdvisory.vue')
  },
  {
    path: '/manCard',
    name: 'manCard',
    component: () => import('@/views/manCard.vue')
  },
  {
    path: '/manCard_wrs',
    name: 'manCard_wrs',
    component: () => import('@/views/manCard_wrs.vue')
  },
  {
    path: '/manCard_zxq',
    name: 'manCard_zxq',
    component: () => import('@/views/manCard_zxq.vue')
  },
  {
    path: '/videoList',
    name: 'videoList',
    component: () => import('@/views/videoList.vue')
  },
  {
    path: '/video',
    name: 'video',
    component: () => import('@/views/video.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
